/**
 * Warioon: one or three jars, bought directly. The sticky bar's button runs the same
 * "Comprar ahora" as the main buy box (Shopify's buy-now button, which goes to checkout
 * with only the chosen pack). Fallback: a cart permalink for the selected variant.
 */
document.addEventListener(
  'click',
  (event) => {
    const sticky = event.target.closest('.sticky-add-to-cart__button');
    if (!sticky) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const section = sticky.closest('.shopify-section') || document;
    const buyNow = section.querySelector(
      '.buy-buttons-block .shopify-payment-button__button, .buy-buttons-block .shopify-payment-button button'
    );
    if (buyNow) {
      buyNow.click();
      return;
    }
    const variantId = section.querySelector('.buy-buttons-block form input[name="id"]')?.value;
    if (variantId) window.location.href = `${window.Shopify?.routes?.root || '/'}cart/${variantId}:1`;
  },
  true
);
